import React from "react";
import t from "prop-types";
import Link from "./link";

const Footer = ({ cprTxtArray }) => (
  <footer className="pf-footer">
    <div className="pf-footer-inner">
      <ul className="links-list">
        <Link text="Privacy" href="/patientsolutions/privacy" />
        <Link text="Terms of Use" href="/legal/terms-of-use" />
        <Link text="Accessibility" href="/legal/accessibility" />
      </ul>
      <div className="pf-footer-disclaimer-text">
        {cprTxtArray.map((__html, index) => (
          <p
            key={`footer_content_${index}`}
            dangerouslySetInnerHTML={{ __html }}
          />
        ))}
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  cprTxtArray: t.arrayOf(t.string),
};

Footer.defaultProps = {
  cprTxtArray: [],
};

export default Footer;

